import { Events } from 'backbone';
import { getLogger } from './logging/logger';

const logger = getLogger('Eventable');

/**
 * @implements {Events}
 */
export default class Eventable {
	constructor() {
		logger.log('[constructor]<Eventable>');
		Object.assign(this, Events);
	}

	on(eventName, callback, context) {
		return this;
	}

	off(eventName, callback, context) {
		return this;
	}

	trigger(eventName, ...args) {
		return this;
	}

	bind(eventName, callback, context) {
		return this;
	}

	unbind(eventName, callback, context) {
		return this;
	}

	once(events, callback, context) {
		return this;
	}

	listenTo(object, events, callback) {
		return this;
	}

	listenToOnce(object, events, callback) {
		return this;
	}

	stopListening(object, events, callback) {
		return this;
	}
}
